import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import useDocumentTitle from "../../../components/helpers/useDocumentTitle";
import PageHeader from "../../../components/shared/PageHeader";
import PageMain from "../../../containers/shared/PageMain";
import apiClient from "../../../components/utils/apiClient";
import MainContent from "../../../containers/shared/MainContent";
import UnitBar from "../../../components/property/unit/UnitBar";
import UnitCard from "../../../components/property/unit/UnitCard";
import BoxContainer from "../../../containers/shared/BoxContainer";
import Button from "../../../components/shared/Button";
import CityConverter from "../../../components/helpers/CityConverter";
import RequestsBar from "../../../components/requests/RequestsBar";
import { FIELDS } from "../../../components/utils/constants";
import RequestsTable from "../../../components/requests/RequestsTable";
import Loading from "../../../components/shared/Loading";
import ModalContainer from "../../../containers/shared/ModalContainer";
import NormalButton from "../../../components/shared/NormalButton";
import moment from "moment";
import { UserContext } from "../../../App";

const SingleUnit = () => {
    const {t,i18n} = useTranslation();
    const { id } = useParams();
    const [unit, setUnit] = useState(null);
    useDocumentTitle(unit?.name);
    const navigate = useNavigate();
    const pageTitle = {title: unit?.name, subTitle: ' '};
    const [requests, setRequests] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [refreshWallet, setRefreshWallet] = useState(()=>new Date().getTime());

    const [showUnitDetails, setShowUnitDetails] = useState(false);
    const [userData, setUserData] = useState(null);
    const [showUnitLimitResetModal, setShowUnitLimitResetModal] = useState(false);

    const [closeAllModals, setCloseAllModals] = useState(false);
    
    const { fields } = useContext(UserContext);

    const getUnit = async () => {
        try {
          const response = await apiClient.get(`/b-units/${id}`);
          if(response?.data) {
            setUnit(response?.data);
            setRequests(response?.data?.subRequests);
          } else {
  
          }
        } catch(err) {}
      }

    useEffect(()=>{
        getUnit();
    },[])

    const handleClickEditUnit = () => {
      navigate(`/ar/unit/edit/${id}`);
    }

    useEffect(()=>{
        if(unit && unit?.deletedAt) {
            navigate(`/ar/property/${unit?.propertyId}`);
        }
    },[unit])

    const handleCloseModal = () => {
        setShowUnitDetails(false);
        setShowUnitLimitResetModal(false);
    }

    const spendingLimitFrequencyOptions = [
        {label:'اليومية', value: 'daily'},
        {label:'الشهرية', value: 'monthly'},
        {label:'الربع سنوية', value: 'quarterly'},
        {label:'السنوية', value: 'yearly'},
    ]

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const handleClickResetUnitLimit = () => {
        setShowUnitDetails(false);
        setShowUnitLimitResetModal(true);
    }

    const handleClickResetUnitLimitAction = async () => {
        try {
            const response = await apiClient.patch(`/b-units/reset-spending-limit/${id}`);
            if([201,204,200].includes(response?.status)) {
                setShowUnitLimitResetModal(false);
                getUnit();
            } else {
            }
        } catch(err) {}
    }

    const handleRefreshRequests = () => {
        getUnit();
        setTimeout(()=>setRefreshWallet(new Date().getTime()),500);
    }

    const getFieldNameAr = (field) => {
        if(fields) {
            return fields?.find(f=>f?.field?.code === field)?.field?.name?.ar;
        } else {
            return FIELDS[field]?.ar;
        }
    }

    const handleChangeRequsetStatus = async (status,id) => {

        let body
        if(status === 'approve') {
        body = {status: 'pending'};
        } else {
        body = {status: 'rejected'};
        }
        const parentId = requests.find(request => request?._id === id)?.businessRequestId;
        try {
        const response = await apiClient.patch(`/b-business-requests/status/${parentId}`,body);
        if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
            setCloseAllModals(true);
            setTimeout(()=>setCloseAllModals(false),1000);
        } else {
        }
        } catch(err) {
        }
    }


  return (
    <>
        {unit && <div>
        <PageHeader key={refreshWallet} pageTitle={pageTitle} isColored userCallback={handleGetUser} />
        <PageMain>
            <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
            <MainContent>
                <BoxContainer label="تفاصيل الوحدة" propertyDetails={true} editText={'تعديل بيانات الوحدة'} propertyEditLink={`/ar/unit/edit/${id}`}>
                    <div className="flex flex-nowrap justify-between self-stretch items-center gap-x-[16px] pb-[24px] mb-[24px] border-b-[1px] border-b-grey-300">
                        <div className="max-w-[70%]">
                            <h2 className="text-[24px] text-grey-900 font-[700] leading-[36px] mb-[5px]">{unit?.name && unit?.name}</h2>
                            {/* <p className="text-[13px] text-grey-950 font-[500] leading-[20px] whitespace-nowrap truncate overflow-hidden">{unit?.description && unit?.description}</p>   */}
                        </div>
                        <div>
                            <div className="w-[324px]">
                                {/* <Button text={'تعديل بيانات الوحدة'} bgColor={'!bg-grey-800'} onClick={()=>handleClickEditUnit()} /> */}
                            </div>
                        </div>
                    </div>
                    <div className="bg-grey-50 rounded-[8px] px-[16px] py-[8px] text-grey-600 mb-[24px]">
                        <h4 className="mb-[4px] text-[24px] font-[500]">{unit?.addressDetails?.addressLine}</h4>
                        <p className="text-[14px] font-[500]"><span className="inline-block align-middle w-[16px] h-[16px] me-[4px] !bg-center !bg-no-repeat brightness-50" style={{background:"url('/assets/images/location.svg')", backgroundSize: "16px"}}></span> العنوان التفصيلي</p>
                    </div>
                    <div className="h-[61px] flex flex-nowrap">
                        <div className="text-[25px] font-[600] text-grey-900 whitespace-nowrap">
                            {unit?.contactName || '-'}
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600">
                                <span className="w-[16px] h-[16px] inline-block align-middle !bg-center !bg-no-repeat me-[4px]" style={{background: "url('/assets/images/profile-circle.svg')"}}></span>
                                المسؤول عن الوحدة
                            </span>
                        </div>
                        <div className="relative w-[193px] h-[61px]"><span className="block w-[1px] h-[40px] bg-grey-300 absolute top-[10px] left-[96px]"></span></div>
                        <div className="text-[25px] font-[600] text-grey-900 whitespace-nowrap">
                            <span dir="ltr">{unit?.contactPhone || '-'}</span>
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600">
                                <span className="w-[16px] h-[16px] inline-block align-middle !bg-center !bg-no-repeat me-[4px]" style={{background: "url('/assets/images/call.svg')"}}></span>
                                رقم الجوال
                            </span>
                        </div>
                        <div className="relative w-[193px] h-[61px]"><span className="block w-[1px] h-[40px] bg-grey-300 absolute top-[10px] left-[96px]"></span></div>
                        <div className="text-[25px] font-[600] text-grey-900 whitespace-nowrap">
                            {requests?.length}
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600">
                                <span className="w-[16px] h-[16px] inline-block align-middle !bg-center !bg-no-repeat me-[4px] brightness-50" style={{background: "url('/assets/images/note.svg')"}}></span>
                                عدد الطلبات
                            </span>
                        </div>
                        {unit?.spendingLimitConfig ? <>
                        <div className="relative w-[193px] h-[61px]"><span className="block w-[1px] h-[40px] bg-grey-300 absolute top-[10px] left-[96px]"></span></div>
                        <div className="text-[24px] font-[500] text-grey-600 whitespace-nowrap">
                            {unit?.spendingLimitConfig?.limit}/<span className={`${unit?.spendingLimitConfig?.consumedAmount <= unit?.spendingLimitConfig?.limit ? 'text-success' : 'text-danger'}`}>{unit?.spendingLimitConfig?.consumedAmount}</span>
                            <svg width="16" height="15" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle ms-[4px]">
                                <g clipPath="url(#clip0_5628_42783)">
                                    <path d="M6.84841 10.6314C6.65212 11.0563 6.52237 11.5173 6.47266 12.0008L10.6266 11.1389C10.8229 10.7141 10.9525 10.253 11.0024 9.76953L6.84841 10.6314Z" fill="#475569"/>
                                    <path d="M10.6242 8.55594C10.8205 8.1312 10.9503 7.67007 11 7.18659L7.76421 7.85833V6.56701L10.6241 5.97378C10.8204 5.54904 10.9502 5.08791 10.9999 4.60443L7.76411 5.27559V0.631619C7.26829 0.90335 6.82796 1.26505 6.47001 1.6917V5.54417L5.17591 5.81265V0C4.68009 0.271635 4.23976 0.633434 3.88181 1.06008V6.08104L0.986256 6.68162C0.789964 7.10636 0.660114 7.56749 0.610307 8.05097L3.88181 7.37236V8.99854L0.375754 9.72577C0.179462 10.1505 0.0497091 10.6116 0 11.0951L3.66986 10.3339C3.96861 10.2732 4.22537 10.1008 4.39231 9.86359L5.06534 8.88966V8.88947C5.13521 8.7887 5.17591 8.66721 5.17591 8.53636V7.10388L6.47001 6.83539V9.41803L10.6241 8.55575L10.6242 8.55594Z" fill="#475569"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_5628_42783">
                                        <rect width="11" height="12" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <span className="block mt-[4px] font-[500] text-[14px] text-grey-600 underline cursor-pointer" onClick={()=>setShowUnitDetails(true)}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="inline-block align-middle me-[4px]">
                                    <path d="M11.8267 15.1665H4.17335C2.51335 15.1665 1.16669 13.8198 1.16669 12.1598V7.67318C1.16669 6.01318 2.51335 4.6665 4.17335 4.6665H11.8267C13.4867 4.6665 14.8334 6.01318 14.8334 7.67318V8.63318C14.8334 8.90651 14.6067 9.13318 14.3334 9.13318H12.9867C12.7534 9.13318 12.54 9.21984 12.3867 9.37984L12.38 9.38652C12.1934 9.56652 12.1067 9.81315 12.1267 10.0665C12.1667 10.5065 12.5867 10.8598 13.0667 10.8598H14.3334C14.6067 10.8598 14.8334 11.0865 14.8334 11.3598V12.1532C14.8334 13.8198 13.4867 15.1665 11.8267 15.1665ZM4.17335 5.6665C3.06669 5.6665 2.16669 6.56651 2.16669 7.67318V12.1598C2.16669 13.2665 3.06669 14.1665 4.17335 14.1665H11.8267C12.9334 14.1665 13.8334 13.2665 13.8334 12.1598V11.8665H13.0667C12.06 11.8665 11.2067 11.1198 11.1267 10.1598C11.0734 9.61316 11.2734 9.07318 11.6734 8.67985C12.02 8.32652 12.4867 8.13318 12.9867 8.13318H13.8334V7.67318C13.8334 6.56651 12.9334 5.6665 11.8267 5.6665H4.17335Z" fill="#475569"/>
                                    <path d="M1.66669 8.7735C1.39335 8.7735 1.16669 8.54683 1.16669 8.2735V5.22687C1.16669 4.23354 1.79335 3.3335 2.72002 2.98017L8.01335 0.980166C8.56002 0.7735 9.16669 0.846865 9.64002 1.1802C10.12 1.51353 10.4 2.05353 10.4 2.63353V5.16685C10.4 5.44019 10.1734 5.66685 9.90002 5.66685C9.62669 5.66685 9.40002 5.44019 9.40002 5.16685V2.63353C9.40002 2.38019 9.28002 2.14685 9.06669 2.00019C8.85335 1.85352 8.60002 1.82018 8.36002 1.91352L3.06669 3.91352C2.52669 4.12018 2.16002 4.64687 2.16002 5.22687V8.2735C2.16669 8.5535 1.94002 8.7735 1.66669 8.7735Z" fill="#475569"/>
                                    <path d="M13.0666 11.8666C12.06 11.8666 11.2066 11.12 11.1266 10.16C11.0733 9.60662 11.2733 9.06663 11.6733 8.6733C12.0133 8.32663 12.48 8.1333 12.98 8.1333H14.3666C15.0266 8.1533 15.5333 8.67327 15.5333 9.31327V10.6866C15.5333 11.3266 15.0266 11.8466 14.3866 11.8666H13.0666ZM14.3533 9.1333H12.9866C12.7533 9.1333 12.54 9.21996 12.3866 9.37996C12.1933 9.56663 12.1 9.81995 12.1266 10.0733C12.1666 10.5133 12.5866 10.8666 13.0666 10.8666H14.3733C14.46 10.8666 14.54 10.7866 14.54 10.6866V9.31327C14.54 9.21327 14.46 9.13997 14.3533 9.1333Z" fill="#475569"/>
                                    <path d="M9.33335 8.5H4.66669C4.39335 8.5 4.16669 8.27333 4.16669 8C4.16669 7.72667 4.39335 7.5 4.66669 7.5H9.33335C9.60669 7.5 9.83335 7.72667 9.83335 8C9.83335 8.27333 9.60669 8.5 9.33335 8.5Z" fill="#475569"/>
                                </svg>
                                حد المصاريف {unit?.spendingLimitConfig?.frequency ? spendingLimitFrequencyOptions.find(option => option?.value === unit?.spendingLimitConfig?.frequency)?.label : ''}
                            </span>
                        </div>
                        </> : ''}
                    </div>
                </BoxContainer>
                {requests !== null ? Array.isArray(requests) && requests?.length > 0 
                ? <div className="mt-[30px] pb-[30px]">
                <RequestsBar requestsCount={requests?.length} />
                <RequestsTable requests={requests} hidePropertyAndUnitNames={true} setIsLoading={setIsLoading} handleRefreshRequests={handleRefreshRequests} handleChangeRequsetStatus={handleChangeRequsetStatus}  closeAllModals={closeAllModals} />
                </div>
                : <div className="pt-[100px] text-center">
                    <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/note.svg')"}}></div>
                    <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لم تقم بأي طلبات لهذة الوحدة الى الان</div>
                    <Link className="inline-block min-w-[320px] h-[48px] leading-[48px] rounded-[8px] text-white bg-grey-800 text-[18px] font-[600]" to={'/ar/requests/add'}>إنشاء طلب جديد</Link>
                </div> : ''}
            </MainContent>
        </PageMain>

        { showUnitDetails && <ModalContainer heading={`المصاريف ${unit?.spendingLimitConfig?.frequency ? spendingLimitFrequencyOptions.find(option => option?.value === unit?.spendingLimitConfig?.frequency)?.label : ''} للوحدة`} maxWidth={'775px'} handleCloseModal={handleCloseModal}>
            <p className="text-[16px] text-grey-600">سيتم اعادة ضبط حد المصاريف {unit?.spendingLimitConfig?.frequency ? spendingLimitFrequencyOptions.find(option => option?.value === unit?.spendingLimitConfig?.frequency)?.label : ''} في {new Date(unit?.spendingLimitConfig?.resetDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'})}</p>
            <div className="h-[1px] w-full bg-grey-100 my-[24px]"></div>
            <div className="bg-grey-50 rounded-[8px]">
                {unit?.unitOrdersLogs && Array.isArray(unit?.unitOrdersLogs) && unit?.unitOrdersLogs?.length > 0 ?
                <>
                <div className="flex flex-nowrap text-grey-900 font-[500] text-[16px] leading-[56px] border-b border-white [&>div]:px-[16px]">
                    <div className="w-[50%]">المعاملة</div>
                    <div className="w-[25%]">المبلغ</div>
                    <div className="w-[25%]">التاريخ</div>
                </div>
                {unit?.unitOrdersLogs?.map((orderLog, index) => <div key={'orderLog'+index} className="flex flex-nowrap border-b border-white text-grey-900 font-[500] text-[16px] leading-[56px] [&>div]:px-[16px]">
                    <div className="w-[50%] text-[14px]">{orderLog?.orderType === 'request' ? 'طلب صيانة' : 'طلب متجر'} {getFieldNameAr(orderLog?.field) || ''} رقم #{orderLog?.prettyId}</div>
                    <div className="w-[25%]">{orderLog?.cost} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /> </div>
                    <div className="w-[25%]">{new Date(orderLog?.createdAt).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'})}</div>
                </div>)}
                </>
                :<p className="text-center font-[500] text-grey-900 py-[15px]">لاتوجد معاملات لعرضها.</p>}
            </div>
            <div className="h-[1px] w-full bg-grey-100 my-[24px]"></div>
            <div className="text-end">
                {(userData?.role?.id === 'OWNER' || userData?.role === 'OWNER') ? <NormalButton isDisabled={!unit?.unitOrdersLogs || (unit?.unitOrdersLogs && Array.isArray(unit?.unitOrdersLogs) && unit?.unitOrdersLogs?.length < 1)} label={'إعادة ضبط حد المصاريف'} onClick={handleClickResetUnitLimit} color={'!bg-white !text-grey-600 !border-[1px] !border-grey-600 !rounded-[8px]'} /> : ''}
                <NormalButton label={'اغلاق'} onClick={handleCloseModal} color={'!bg-grey-800 !ms-[24px] !w-[228px] !text-center'} />
            </div>
        </ModalContainer> }

        { showUnitLimitResetModal && <ModalContainer heading={`إعادة ضبط حد المصاريف`} maxWidth={'775px'} handleCloseModal={handleCloseModal}>
            <p className="text-[16px] text-grey-600 pb-[24px]">هل انت متاكد من تنفيذ هذا الطلب ؟</p>
            <div className="text-end">
                <NormalButton label={'إلغاء الطلب'} onClick={handleCloseModal} color={'!bg-grey-800 !w-[228px] !text-center'} />
                <NormalButton label={'تنفيذ الطلب'} onClick={handleClickResetUnitLimitAction} color={'!bg-white !w-[228px] !text-grey-600 !border-[1px] !border-grey-600 !rounded-[8px] !ms-[24px]'} />
            </div>
        </ModalContainer> }

        </div>}
        {isLoading && <Loading />}
    </>
  );
};

export default SingleUnit;
